import { render, staticRenderFns } from "./BibleResultsList.vue?vue&type=template&id=5174110d&scoped=true&class=bible-results-list"
import script from "./BibleResultsList.vue?vue&type=script&lang=js"
export * from "./BibleResultsList.vue?vue&type=script&lang=js"
import style0 from "./BibleResultsList.vue?vue&type=style&index=0&id=5174110d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174110d",
  null
  
)

export default component.exports